/*
 *  Board Service
 */
import { Injectable } from '@angular/core';
import * as _ from 'lodash-es';
import { TrackerService } from '../../../plugins/tracker/services/tracker.service';

function collapseOption(id, label, description) {
    return {
        id: id,
        label: label,
        description: description
    };
}

@Injectable()
export class BoardService {
    private collapseOptionMap = [
        collapseOption(0, 'Auto', 'Use the default behavior for each type of data.'),
        collapseOption(1, 'Collapse', 'Collapse categories with zero items.'),
        collapseOption(2, 'Hide', 'Hide categories with zero items.'),
        collapseOption(3, 'None', 'Leave all categories open, regardless of item count.')
    ];

    private sharedOptionMap = {
        'Private': 'N',
        'Shared': 'Y'
    };
    public collapseOptions;
    public sharedOptions;
    public collapseChoiceOptions;

    constructor(private trackerService: TrackerService) {

        this.collapseOptions = this.collapseOptionMap;
        this.sharedOptions = this.sharedOptionMap;

        // Options display requires label => id mapping,
        // backwards from the normal map
        this.collapseChoiceOptions = this.collapseOptionMap.reduce(function(carry, item) {
            carry[item.label] = item.id;
            return carry;
        }, {});
    }

    private mapExtraFields(fields) {
        return _.filter(fields, {isExtraField: true, isEnabled: true}).map((field) => {
            var selectableField: any = {
                id: field.id,
                alias: field.alias,
                description: field.fieldName,
                isExtraField: false,
                elements: field.fieldElements,
                selected: false
            };

            return selectableField;
        });
    }

    private filterIntrinsicFields(fields) {
        return _.filter(fields, function(field) {
            return !field.isExtraField && ['priority', 'sprint', 'waitingFor'].includes(field.alias);
        });
    }

    private mapIntrinsicFields(fields) {
        let filteredIntrinsicFields: any = this.filterIntrinsicFields(fields);
        return _.map(filteredIntrinsicFields, (field) => {
            var selectableField = {
                id: 0,
                alias: field.alias,
                description: field.fieldName,
                isExtraField: false,
                elements: [],
                selected: false
            };

            switch(field.alias) {
                case 'priority':
                    selectableField.elements = this.trackerService.fields.builtIn.priority.getList();
                    break;

                case 'sprint':
                    selectableField.elements = field.fieldElements;
                    break;

                case 'waitingFor':
                    selectableField.elements = this.trackerService.fields.builtIn.waiting_for.getList();
                    break;
            }

            return selectableField;
        });
    }

    public getSelectableFieldsFromTracker(tracker) {
        var fields = _.filter(_.get(tracker, 'fields', []), function(field) {
            return [1, 2, 3, 5, 7, 8, 12].includes(field.fieldType);
        });

        let extraFields: any = this.mapExtraFields(fields);
        let intrinsictFields: any = this.mapIntrinsicFields(fields);
        let filteredFields = _.union(intrinsictFields, extraFields);
        //Adds assignees
        filteredFields.push({id: 0, alias: 'assignee', description: 'Assignees', isExtraField: true, selected: false});

        return filteredFields;
    }

    public getSelectableIntrinsicFields() {
        return [
            {id: 0, alias: 'assignee', description: 'Assignees', isExtraField: true, selected: false},
            {id: 0, alias: 'priority', description: 'Priority', isExtraField: false, selected: false},
            {id: 0, alias: 'sprint', description: 'Sprint', isExtraField: false, selected: false},
            {id: 0, alias: 'status', description: 'Status', isExtraField: false, selected: false},
            {id: 0, alias: 'waitingFor', description: 'Waiting For', isExtraField: false, selected: false}
        ];
    }

    public getSections() {
        return [
            {id: 'query', description: 'Query'},
            {id: 'sprint', description: 'Sprint'},
            {id: 'release', description: 'Release'}
        ]
    }

    public getCollapseLabel(value) {
        const keys = Object.keys(this.collapseOptionMap);
        if (0 <= value && value < keys.length) {
            return keys[value];
        }
        return null;
    }
}
